<script lang="ts">
  import type { SpotPriser } from "$lib/types/spotPriser";
  import MetaData from "$lib/MetaData.svelte";
  import SpotPriceDataController from "./SpotPriceDataController.svelte";
  import { onMount } from "svelte";
  import theTime from "$lib/utils/the-time";

  const title = "Dagens strømpris – dag for dag";
  let spotPriser: SpotPriser[] = $state([]);
  let message = $state("");

  onMount(async () => {
    const today = theTime().toPlainDateString();
    const thirtyDaysAgo = theTime().goes({ DD: -30 }).toPlainDateString();
    const fetchPrices = async () => {
      try {
        const res = fetch(
          `https://api.servicekanal.no/spotpriser/fradatotildato/${thirtyDaysAgo}/${today}`
        ).then((r) => r.json());
        return await res;
      } catch (error) {
        console.log("Error fetching spotpriser!", error);
        message = "Sportpriser er utilgjengelig for øyeblikket. Prøv igjen senere.";
        return [];
      }
    };
    const allPrices: SpotPriser[] = (await fetchPrices()) as SpotPriser[];

    if (allPrices.length) {
      const allPricesMva = allPrices.map((omraade) => {
        if (omraade.omrade !== "NO4") {
          return {
            ...omraade,
            dager: omraade.dager.map((dag) => {
              return {
                ...dag,
                dognpris: dag.dognpris * 1.25,
              };
            }),
          };
        }
        return omraade;
      });

      spotPriser = allPricesMva;
    }
  });
</script>

<MetaData
  data={{
    title,
    description: "Følg med på spotprisen i Norge, dag for dag og time for time.",
  }}
/>

<div>
  <p class="mx-edge-x mt-0 mb-1 text-sm">Tall for siste 30 dager.</p>
  {#if spotPriser}
    <SpotPriceDataController {spotPriser} />
  {/if}
  {#if message}
    <p class="mx-edge-x">{message}</p>
  {/if}
</div>

<style lang="postcss">
  div {
    --no1-line-color: var(--uer);
    --no2-line-color: var(--skog);
    --no3-line-color: var(--primary);
    --no4-line-color: var(--lysning);
    --no5-line-color: var(--geitrams);
  }
</style>
